import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { show_proper_words } from "../../utils/Constant";
import PageLoading from "../../components/loader/PageLoading";
import { useIds } from "../../hook/AdminContext";
import { useSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";
import {
  _get_mindset_list_blog_api,
  _get_training_list_blog_api,
} from "../../DAL/partner/partners";
import { s3baseUri } from "../../config/config";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import { Carousel } from "react-bootstrap";
import CardCarousalSkeleton from "../../components/loader/CradCarousalSkelator";

export default function HospitalityMindsetSource() {
  const location = useLocation();
  const navigate = useNavigate();
  const { findId, setBreadCrumb } = useIds();
  const firstSegment = location.pathname.split("/")[1];
  const { enqueueSnackbar } = useSnackbar();
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [partnersObj, setPartnersObj] = useState({});
  const [slider_blogs, set_Slider_blogs] = useState([]);

  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const load_more_path = "api/mindset_source/list?page=0&limit=50";
  console.log(findId, "findIdfindId");
  console.log(partnersObj, "partnersObjpartnersObjpartnersObj");

  const fetchCategories = async (path, loading, id) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }
    if (!id) {
      id = localStorage.getItem("source_id");
      console.log(id, "ididididid");
    }
    const response = await _get_mindset_list_blog_api(id, "", path);
    if (response.code === 200) {
      set_Slider_blogs(response?.slider_blogs);

      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      if (loading) {
        let new_array = categories.concat(response.mindset_source_categories);
        setCategories(new_array);
        setPageNumber((prev) => prev + 1);
      } else {
        setCategories(response.mindset_source_categories);
        setPageNumber(1);
      }
      setPartnersObj(response.mindset_source);
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreData = () => {
    setIsLoadingMore(true);
    fetchCategories(loadMorePath, true, findId);
  };

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath, observer]
  );

  // useEffect(() => {
  //   if (!loading) {
  //     const timeoutId = setTimeout(() => {
  //       fetchCategories(loadMorePath, searchText);
  //     }, 800);
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [searchText]);

  const handleNavigateDeatil = (value) => {
    navigate(`/${firstSegment}/mindset-source/blog-list/${value._id}`, {
      state: value,
    });
  };
  const handleDetailAffiliations = (hrBlogList) => {
    navigate(`/${firstSegment}/mindset-source/blog-detail/${hrBlogList?._id}`, {
      state: { blog: hrBlogList },
    });
  };

  useEffect(() => {
    fetchCategories(load_more_path, false, findId);
  }, []);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
      {
        name: `Mindset Source`,
        path: "",
        active: true,
      },
    ]);
  }, []);

  if (loading) {
    return <CardCarousalSkeleton />;

    // return <PageLoading />;
  }

  return (
    <div className="container-fluid">
      <div className="d-flex mt-3">
        <div className="heading-main mb-3">
          <h2>Mindset Source Blogs</h2>
        </div>
      </div>

      <div className="row g-4">
        {slider_blogs?.length > 0 ? (
          <Carousel interval={3000} pause={false} controls indicators>
            {slider_blogs?.map((blog, index) => (
              <Carousel.Item key={index}>
                <div className="container row d-flex align-items-center carousel-item-container">
                  <div className="col-md-6 p-0">
                    <div
                      className="blog-card  p-4 ms-4 heading-h3"
                      style={{
                        borderRadius: "10px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <h3 className="mb-4">{blog?.title}</h3>
                      <p>{blog?.short_description}</p>
                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <button
                          className="small-button-cotain-view-all"
                          onClick={() => handleDetailAffiliations(blog)}
                        >
                          Read More
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <img
                      className="d-block w-100 card-img"
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: "10px",
                      }}
                      src={s3baseUri + blog?.image}
                      alt={blog?.name}
                    />
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <RecordNotFound title="No Blogs " />
        )}
        <div className="heading-main-h2 ">
          <h2>Mindset Source Categories</h2>
        </div>
        {categories && categories.length > 0 ? (
          <>
            {categories.map((topic, index) => (
              <div
                key={index}
                className="col-12 col-sm-6 col-md custom-col-5 mt-3 d-flex justify-content-center"
              >
                <div
                  className="card shadow-sm w-100 cursor-pointer"
                  onClick={() => handleNavigateDeatil(topic)}
                >
                  <img
                    onClick={() => handleNavigateDeatil(topic)}
                    style={{ cursor: "pointer" }}
                    src={s3baseUri + topic?.icon_image}
                    alt="logo"
                    className="card-img-top-interview p-0"
                  />
                  <div className="card-body card-content-partners">
                    <h5 className="card-title">{topic.name}</h5>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="col-12">
            <RecordNotFound title="Data Not" />
          </div>
        )}
        {totalPages >= pageNumber ? (
          <div className="col-12 text-center mt-3">
            <span
              ref={lastBookElementRef}
              className="mt-3"
              onClick={loadMoreData}
              id="load-more-feed"
            >
              {isLoadingMore ? (
                <CircularProgress color="primary" size="1.5rem" />
              ) : (
                "Load More"
              )}
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
